import { render, staticRenderFns } from "./MfTabs.vue?vue&type=template&id=48af27cc&scoped=true&"
import script from "./MfTabs.vue?vue&type=script&lang=js&"
export * from "./MfTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af27cc",
  null
  
)

export default component.exports